var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgSuccessCheck = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6565_12757)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.257 5.89696C9.42101 5.73294 9.42101 5.46702 9.257 5.303C9.09297 5.13898 8.82705 5.13898 8.66302 5.303L6.16001 7.80601L5.337 6.98299C5.17298 6.81897 4.90705 6.81897 4.74303 6.98299C4.57901 7.14702 4.57901 7.41294 4.74303 7.57696L5.86303 8.69696C6.02705 8.86098 6.29297 8.86098 6.457 8.69696L9.257 5.89696Z",
    fill: "#4FC814"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00001 0.97998C3.67526 0.97998 0.980011 3.67523 0.980011 6.99998C0.980011 10.3247 3.67526 13.02 7.00001 13.02C10.3248 13.02 13.02 10.3247 13.02 6.99998C13.02 3.67523 10.3248 0.97998 7.00001 0.97998ZM1.82001 6.99998C1.82001 4.13915 4.13918 1.81998 7.00001 1.81998C9.86085 1.81998 12.18 4.13915 12.18 6.99998C12.18 9.86082 9.86085 12.18 7.00001 12.18C4.13918 12.18 1.82001 9.86082 1.82001 6.99998Z",
    fill: "#4FC814"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6565_12757"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSuccessCheck, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/SuccessCheck.3bc9c118.svg";
export { ForwardRef as ReactComponent };